<template>
  <page-outline 
    :title="$t('Webheader.connector_list_'+entitiesType+'_'+role+'_'+type)"
    :show-refresh="true"
    :refresh-disabled="activateSpinner"
    @refresh="onRefresh">
    
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    
    <template slot="pageContent">
      <b-container fluid class="listPage">
        <b-tabs :value="role == 0 ? 1 : 0" nav-class="d-none">
          <!-- Credential LIST -->
          <b-tab :class="role == 0 ? 'd-none': ''" :title="$t('common.routing.receiver')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover relative responsive
                           v-if="mqseriesCredentialFields.length"
                           class="mt-3 table-striped"
                           :items="mqseriesCredentialList"
                           :fields="mqseriesCredentialFields"
                           selectable select-mode="single" @row-selected="seeMQSeriesCredentialDetails">
                           <template #cell(Active)="data">
                             {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                           </template>
                  </b-table>

                  <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab :class="role == 1 ? 'd-none': ''" :title="$t('common.routing.responder')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover relative responsive
                           v-if="mqseriesFields.length"
                           class="mt-3 table-striped table-hover"
                           :items="mqseriesConfigList"
                           :fields="mqseriesFields"
                           selectable select-mode="single" @row-selected="seeMQSeriesDetails">
                           <template #cell(Active)="data">
                             {{data.value === '1' ? $t('common.routing.yes') : $t('common.routing.no')}}
                           </template>
                  </b-table>

                  <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </b-container>
    </template>
  </page-outline>

</template>

<script>

import Spinner from '@/components/common/spinner.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'MQSeriesList',
  components: {
    PageOutline,
    AppButton,
    'spinner': Spinner
  },
  props: {
    idEngine: {
      default: '0'
    },
    entitiesType: {
      default: 'rvm'
    },
    id: {
      default: 'null'
    },
    role: {
      default: 'null'
    },
  },
  computed: {
    mqseriesFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center' },
        { key: 'ConnectionMode', label: this.$t('common.routing.connection_mode'), class: 'text-center' },
        { key: 'ConnectionType', label: this.$t('common.routing.connection_type'), class: 'text-center' },
        { key: 'QueueManager', label: this.$t('common.routing.queue_manager'), class: 'text-center' },
        { key: 'ChannelName', label: this.$t('common.routing.channel_name'), class: 'text-center' },
        { key: 'QueueName', label: this.$t('common.routing.queue_name'), class: 'text-center' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center' }
      ]
    },
    mqseriesCredentialFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center' },
        { key: 'TimeOut', label: this.$t('common.routing.timeout'), class: 'text-center' },
        // { key: 'ConnectionMode', label: this.$t('common.routing.connection_mode'), class: 'text-center' },
        // { key: 'ConnectionType', label: this.$t('common.routing.connection_type'), class: 'text-center' },
        { key: 'QueueManager', label: this.$t('common.routing.queue_manager'), class: 'text-center' },
        { key: 'ChannelName', label: this.$t('common.routing.channel_name'), class: 'text-center' },
        { key: 'QueueName', label: this.$t('common.routing.queue_name'), class: 'text-center' },
        { key: 'Active', label: this.$t('common.routing.active'), class: 'text-center' }
      ]
    },
  },
  data () {
    return {
      activateSpinner: false,
      interProcessConfigList: [],
      mqseriesConfigList: [],
      mqseriesCredentialList: [],
      FTPConfigList: [],
      FTPCredentialList: [],
      pageCounter: 0,
      returnUrl: '',
      entityType: 0,
      remoteFolderConfigList: [],
      tabName: 1,
      tabIndex: 0,
      type: 0,
      webServiceConfigList: [],
      webServiceCredentialList: [],
    }
  },
  created () {
    if (this.entitiesType == 'requester'){
      this.entityType = '0'
      this.returnUrl = '/routing/configlist/1/0/' + this.entitiesType
    }
    if (this.entitiesType == 'responder'){
      this.type = 1
      this.entityType = '2'
      this.returnUrl = '/routing/configlist/0/1/' + this.entitiesType
    }
    if (this.entitiesType == 'rvm'){
      this.entityType = '1'
      this.returnUrl = '/routing/configlist/'+ this.role + '/0/' + this.entitiesType
    }
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    role(newValue) {
      this.tabName = newValue == '1' ? 1 : 0
    },
  },
  methods: {
    getConfigMQSeries () {
      let that = this
      this.$engine.get(this.idEngine).routing.config.mqseries.fetch({
        entityType: this.entityType,
        Role: this.role,
        IdConfigRouting: this.id
      })
      .then(resp => {
        let mqseriesList = {}

        mqseriesList = resp.data.MQSeriesConfig
        mqseriesList.forEach(mqseries=> {
          mqseries.idEngine = this.idEngine
          if (mqseries.SSL === '1') {
            mqseries.SSLActive = this.$t('common.routing.yes')
          } else {
            mqseries.SSLActive = this.$t('common.routing.no')
          }
        })
        this.mqseriesConfigList = this.mqseriesConfigList.concat(mqseriesList)

        mqseriesList = {}

        mqseriesList = resp.data.MQSeriesCredential
        this.mqseriesCredentialList.forEach(mqseries=> {
          mqseries.idEngine = this.idEngine
          if (mqseries.SSL === '1') {
            mqseries.SSLActive = this.$t('common.routing.yes')
          } else {
            mqseries.SSLActive = this.$t('common.routing.no')
          }
        })
        this.mqseriesCredentialList = this.mqseriesCredentialList.concat(mqseriesList)
        that.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        if (error.code === 'ERR_NETWORK') {
        } else {
          errorMessageAlert(error, that)
        }
      })
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0

      this.mqseriesConfigList = []
      this.mqseriesCredentialList = []
      this.getConfigMQSeries()

      this.$f7.pullToRefreshDone()
    },
    seeMQSeriesDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.get(this.idEngine).routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesConfigurationDetails/details/' + this.idEngine + '/' + this.entitiesType + '/' + this.role + '/' + this.id})
    },
    seeMQSeriesCredentialDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.get(this.idEngine).routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesCredentialDetails/details/' + this.idEngine + '/' + this.entitiesType + '/' + this.role + '/' + this.id})
    },
    goBack () {
      if (this.returnUrl) {
        loadPage(this, {url: this.returnUrl})
      } else {
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
            loadPage(this, {url: '/home/'})
          } else {
            this.$f7.mainView.router.back()
          }
          this.$bus.$emit('router-back')
        }
      }
    }
  }
}
</script>
